export enum SubmitType {
  refresh = 'refresh',
  save = 'save',
  update = 'update',
}
